(function () {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('Administration', Administration);

    Administration.$inject = ['$resource'];

    function Administration ($resource) {
        var service = $resource('api/administration', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                } },
        });
        return service;
    }
})();
